import { useEffect } from 'react';

import { H3, P2 } from '../../../styles/FontStyles';

import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../app/hooks';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { colors } from '../../../styles/GlobalStyles';
import { Overlay } from '../Overlay';
import { getMyHubsUnicaPay } from '../Portfolio.actions';

import apple from '../../../assets/images/backoffice/apple.jpg';
import google from '../../../assets/images/backoffice/google.jpg';

import { UnicaPayItem } from './UnicaPayItem';

export const UnicaPaySummary = () => {
  const dispatch = useDispatch();

  const { unicapay } = useAppSelector((state) => state.portfolio);

  useEffect(() => {
    dispatch(getMyHubsUnicaPay());
  }, [dispatch]);

  useEffect(() => {}, [unicapay]);

  return (
    <>
      <Flexed mb='40' center between rowSM>
        <H3 mbSM='10' color={colors.primary900}>
          My unica pay Cards
        </H3>

        <Flexed between center gap='1'>
          <a
            href='https://apps.apple.com/si/app/unica-pay-finance-evolved/id6757447315'
            target='_blank'
            rel='noreferrer'>
            <img src={apple} style={{ height: 55, cursor: 'pointer' }} alt='' />
          </a>
          <a
            href='https://play.google.com/store/apps/details?id=com.domainunica.appunica&pli=1'
            target='_blank'
            rel='noreferrer'>
            <img
              src={google}
              style={{ height: 62, cursor: 'pointer' }}
              alt=''
            />
          </a>
        </Flexed>
      </Flexed>

      <div>
        {unicapay?.orders?.map((item: any, index: number) => (
          <UnicaPayItem key={index} item={item} />
        ))}
      </div>
      {unicapay?.orders?.length === 0 && (
        <P2 center color={colors.neutral500}>
          No data available
        </P2>
      )}

      <Overlay />
    </>
  );
};
